import styles from "./Toggle.module.scss";
import { ReactElement, useEffect, useRef, useState } from "react";
import classNames from "classnames";

export function Toggle(props: {
  value: string;
  onChange: (value: string) => void;
  options: Array<{ label: string; value: string; icon?: ReactElement }>;
  className?: string;
  disabled?: boolean;
  id: string;
  [prop: string]: any;
}) {
  const { value, onChange, options, ...validHtmlAttributes } = props;
  const toggleRef = useRef<null | HTMLDivElement>(null);
  const [highlightWidth, setHighlightWidth] = useState(0);
  const [highlightLeft, setHighlightLeft] = useState(0);

  useEffect(() => {
    if (toggleRef.current) {
      const selectedLabel: HTMLLabelElement | null =
        toggleRef.current.querySelector(
          `input[value=${CSS.escape(value)}] + label`,
        );
      if (selectedLabel) {
        const selectedLabelRect = selectedLabel.getBoundingClientRect();
        setHighlightWidth(selectedLabelRect.width);
        setHighlightLeft(selectedLabel.offsetLeft);
      }
    }
  }, [value, options]);

  const toggleClassNames = classNames({
    [styles.toggle]: true,
    [styles.toggleDisabled]: props.disabled,
    [props.className as string]: props.className,
  });

  return (
    <div {...validHtmlAttributes} className={toggleClassNames} ref={toggleRef}>
      {options.length > 1 &&
        options.map((opt) => (
          <span key={opt.value}>
            <input
              name={`${opt.value}-${props.id}`}
              id={`${opt.value}-${props.id}`}
              type={"radio"}
              value={opt.value}
              checked={value === opt.value}
              onChange={(e) => onChange(e.target.value)}
            />
            <label title={opt.label} htmlFor={`${opt.value}-${props.id}`}>
              <span>
                {opt.icon} {opt.label}
              </span>
            </label>
          </span>
        ))}
      <div style={{ width: `${highlightWidth}px`, left: highlightLeft }} />
    </div>
  );
}
